import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getDataTools = () =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/tools/get-data`);

export const updateBroadcastMsg = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/tools/broadcast-message/update`, params)

export const updateBrandDetect = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/tools/brand-detect/update`, params)